import {
    Container,
    Title,
    Accordion,
    useMantineTheme,
    Group,
    Stack
} from '@mantine/core';
import classes from './FAQ.module.css';
import {useConfig} from "../ConfigContext";
import React from "react";

export function FAQ() {
    const theme = useMantineTheme();
    const {faqs} = useConfig();

    const items = faqs.map((faq) => (
        <Accordion.Item key={faq.question} className={classes.item} value={faq.question}>
            <Accordion.Control>
                <Group>
                    {faq.icon ? React.createElement(faq.icon, {
                        stroke: 1.5,
                        color: theme.colors.accent[0]
                    }) : <></>} {faq.question}
                </Group>
            </Accordion.Control>
            <Accordion.Panel>{faq.answer}</Accordion.Panel>
        </Accordion.Item>
    ));

    return (
        <Stack>
            <Title ta="center" c={theme.colors.brand[6]} className={classes.title}>
                Frequently Asked Questions
            </Title>
            <Group grow align="start">
                <Container size="xl" className={classes.wrapper}>
                    <Accordion variant="separated">
                        {items}
                    </Accordion>
                </Container>
            </Group>
        </Stack>
    );
}
